<mb-base-modal>
  <div class="content" dialog-content>
    <div class="cmp-base-error-message">
      <div>
        <span class="icon-danger mb-icon mb-icon-attention mb-icon-xxl"></span>
        <h5 class="error-headline" [innerHtml]="headline | translate"></h5>
        @if (message) {
          <p class="message" [innerHtml]="message | translate"></p>
        }
        @if (actionLabel) {
          <button class="btn btn-primary" type="button" (click)="triggerAction()">
            <span [innerHtml]="actionLabel | translate"></span>
          </button>
        }
      </div>
    </div>
  </div>
</mb-base-modal>
